module.exports = __webpack_public_path__ + "static/media/map_marker_icon.ac05fd83.svg";